import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { pub } from "../../lib/pubThemeClasses";

/** Boş liste / filtre sonucu için standart blok (pub tasarımıyla uyumlu). */
export default function EmptyState({
  title = "Sonuç bulunamadı",
  description = "Filtreleri değiştirerek tekrar deneyebilirsin",
  actionLabel = "Tümünü göster",
  onAction,
  /** Link kullanılacaksa (ör. CMS boş ana sayfa dönüşü) */
  actionTo,
  ...rest
}) {
  const actionClassName = `inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-[#FF4F00] transition-colors ${pub.hoverText}`;

  let actionEl = null;
  if (actionTo) {
    actionEl = (
      <Link to={actionTo} data-testid="empty-state-link" className={actionClassName}>
        {actionLabel} <ArrowUpRight className="w-4 h-4" />
      </Link>
    );
  } else if (typeof onAction === "function") {
    actionEl = (
      <button type="button" data-testid="empty-state-clear" onClick={onAction} className={actionClassName}>
        {actionLabel} <ArrowUpRight className="w-4 h-4" />
      </button>
    );
  }

  return (
    <div {...rest}>
      <div className={`text-center px-6 py-16 md:py-20 rounded-sm border ${pub.borderSubtle} ${pub.softPanel}`}>
        <h2 className={`font-sans text-xl md:text-2xl font-semibold tracking-tight mb-3 ${pub.heroHeading}`}>{title}</h2>
        <p className={`font-sans text-sm md:text-base max-w-md mx-auto mb-8 ${pub.muted}`}>{description}</p>
        {actionEl}
      </div>
    </div>
  );
}
